// Components
import { Table as TableComponent, TableFlex } from "./Table";
import { Thead } from "./Thead";
import { Tbody, MemoizedTbody } from "./Tbody";
import { Tr } from "./Tr";
import { Td } from "./Td";
import { Th } from "./Th";
import { TableCheckbox } from "./TableCheckbox";

// Hooks
import { useHasScrolled } from "./useHasScrolled";
import { useScrollPosition } from "./useScrollPosition";
import { useSelect } from "./useSelect";
import { useSort } from "./useSort";

// Types
import type {
  TableProps,
  TableTheadProps,
  TableTbodyProps,
  TableTrProps,
  TableTdProps,
  TableThProps,
  TableRowSize,
  SortDirections,
  SortState,
  SelectedValues
} from "./Table.types";
import type { TableCheckboxProps } from "./TableCheckbox";

// Create the Table namespace for internal use and stories
const Table = Object.assign(TableComponent, {
  Table: TableComponent,
  TableFlex,
  Thead,
  Tbody,
  MemoizedTbody,
  Tr,
  Td,
  Th,
  TableCheckbox,
  useHasScrolled,
  useScrollPosition,
  useSelect,
  useSort
});

// Export the Table namespace for stories
export { Table };

// Export components and hooks individually
export {
  TableComponent,
  TableFlex,
  Thead,
  Tbody,
  MemoizedTbody,
  Tr,
  Td,
  Th,
  TableCheckbox,
  useHasScrolled,
  useScrollPosition,
  useSelect,
  useSort
};

// Export types
export type {
  TableProps,
  TableTheadProps,
  TableTbodyProps,
  TableTrProps,
  TableTdProps,
  TableThProps,
  TableRowSize,
  SortDirections,
  SortState,
  SelectedValues,
  TableCheckboxProps
};

// Default export for internal usage
export default Table;
